import { defineMessages } from "react-intl"

const baseId = "t.global.filterLabels."

export default defineMessages({
  // ACTIONS
  CTA_CANCEL: {
    id: baseId + "CTA_CANCEL",
    defaultMessage: "Cancel",
  },
  CTA_CLOSE: {
    id: baseId + "CTA_CLOSE",
    defaultMessage: "CLOSE",
  },
  CTA_FILTER: {
    id: baseId + "CTA_FILTER",
    defaultMessage: "Filter",
  },
  CTA_Search: {
    id: baseId + "CTA_Search",
    defaultMessage: "Search",
  },

  // SWITCH LABELS
  advancedSearchFilterLabelForm: {
    id: baseId + "advancedSearchFilterLabelForm",
    defaultMessage: " ",
  },
  advancedSearchFilter2LabelForm: {
    id: baseId + "advancedSearchFilter2LabelForm",
    defaultMessage: "Advanced Search",
  },
  allFilterLabelForm: {
    id: baseId + "allFilterLabelForm",
    defaultMessage: "Multiple search",
  },
  allBRFilterLabelForm: {
    id: baseId + "allBRFilterLabelForm",
    defaultMessage: "Multiple BR search",
  },

  // FIELDS
  abilitationFilterLabelForm: {
    id: baseId + "abilitationFilterLabelForm",
    defaultMessage: "Abilitation",
  },
  abilitationDescriptionFilterLabelForm: {
    id: baseId + "abilitationDescriptionFilterLabelForm",
    defaultMessage: "Abilitation description",
  },
  accountIdFilterLabelForm: {
    id: baseId + "accountIdFilterLabelForm",
    defaultMessage: "Account id",
  },
  actionFilterLabelForm: {
    id: baseId + "actionFilterLabelForm",
    defaultMessage: "Action",
  },
  activeFilterLabelForm: {
    id: baseId + "activeFilterLabelForm",
    defaultMessage: "Active",
  },
  applicantFilterLabelForm: {
    id: baseId + "applicantFilterLabelForm",
    defaultMessage: "Applicant",
  },
  applicationFilterLabelForm: {
    id: baseId + "applicationFilterLabelForm",
    defaultMessage: "Application",
  },
  applicationDescriptionFilterLabelForm: {
    id: baseId + "applicationDescriptionFilterLabelForm",
    defaultMessage: "Application description",
  },
  applicationNameFilterLabelForm: {
    id: baseId + "applicationNameFilterLabelForm",
    defaultMessage: "Application name",
  },
  approverFilterLabelForm: {
    id: baseId + "approverFilterLabelForm",
    defaultMessage: "Approver",
  },
  attributeFilterLabelForm: {
    id: baseId + "attributeFilterLabelForm",
    defaultMessage: "Attribute",
  },
  attributeValueFilterLabelForm: {
    id: baseId + "attributeValueFilterLabelForm",
    defaultMessage: "Attribute value",
  },
  auditDateFilterLabelForm: {
    id: baseId + "auditDateFilterLabelForm",
    defaultMessage: "Audit date",
  },
  auditDateFilter2LabelForm: {
    id: baseId + "auditDateFilter2LabelForm",
    defaultMessage: "Audit date",
  },
  availableFilterLabelForm: {
    id: baseId + "availableFilterLabelForm",
    defaultMessage: "Available",
  },
  baoFilterLabelForm: {
    id: baseId + "baoFilterLabelForm",
    defaultMessage: "BAO",
  },
  beneficiaryFilterLabelForm: {
    id: baseId + "beneficiaryFilterLabelForm",
    defaultMessage: "Beneficiary",
  },
  codeFilterLabelForm: {
    id: baseId + "codeFilterLabelForm",
    defaultMessage: "Code",
  },
  companyFilterLabelForm: {
    id: baseId + "companyFilterLabelForm",
    defaultMessage: "Company",
  },
  configurationFilterLabelForm: {
    id: baseId + "configurationFilterLabelForm",
    defaultMessage: "Configuration",
  },
  conflictFilterLabelForm: {
    id: baseId + "conflictFilterLabelForm",
    defaultMessage: "Conflict",
  },
  conflictApplicationFilterLabelForm: {
    id: baseId + "conflictApplicationFilterLabelForm",
    defaultMessage: "Conflict application",
  },
  conflictEntitlementFilterLabelForm: {
    id: baseId + "conflictEntitlementFilterLabelForm",
    defaultMessage: "Conflict entitlement",
  },
  counterFilterLabelForm: {
    id: baseId + "counterFilterLabelForm",
    defaultMessage: "Counter",
  },
  counterCodeFilterLabelForm: {
    id: baseId + "counterCodeFilterLabelForm",
    defaultMessage: "Counter code",
  },
  counterIdFilterLabelForm: {
    id: baseId + "counterIdFilterLabelForm",
    defaultMessage: "ID",
  },
  counterLastIdFilterLabelForm: {
    id: baseId + "counterLastIdFilterLabelForm",
    defaultMessage: "Last ID",
  },
  counterLengthFilterLabelForm: {
    id: baseId + "counterLengthFilterLabelForm",
    defaultMessage: "Length",
  },
  counterPrefixFilterLabelForm: {
    id: baseId + "counterPrefixFilterLabelForm",
    defaultMessage: "Prefix",
  },
  creationDateFilterLabelForm: {
    id: baseId + "creationDateFilterLabelForm",
    defaultMessage: "Date start at",
  },
  creationDateFilter2LabelForm: {
    id: baseId + "creationDate2FilterLabelForm",
    defaultMessage: "Date end at",
  },
  defaultFilterLabelForm: {
    id: baseId + "defaultFilterLabelForm",
    defaultMessage: "Default",
  },
  delegantFilterLabelForm: {
    id: baseId + "delegantFilterLabelForm",
    defaultMessage: "Delegante",
  },
  delegatedFilterLabelForm: {
    id: baseId + "delegantFilterLabelForm",
    defaultMessage: "Delegante",
  },
  descriptionFilterLabelForm: {
    id: baseId + "descriptionFilterLabelForm",
    defaultMessage: "Descrizione",
  },
  destinationTargetIdFilterLabelForm: {
    id: baseId + "destinationTargetIdFilterLabelForm",
    defaultMessage: "Destination target",
  },
  destinationIdentitySystemIdFilterLabelForm: {
    id: baseId + "destinationIdentitySystemIdFilterLabelForm",
    defaultMessage: "Destination identity",
  },
  displayOrderFilterLabelForm: {
    id: baseId + "displayOrderFilterLabelForm",
    defaultMessage: "displayOrderFilter",
  },
  durationFilterLabelForm: {
    id: baseId + "durationFilterLabelForm",
    defaultMessage: "Duration",
  },
  emailFilterLabelForm: {
    id: baseId + "emailFilterLabelForm",
    defaultMessage: "Email",
  },
  emergencyNameFilterLabelForm: {
    id: baseId + "emergencyNameFilterLabelForm",
    defaultMessage: "Emergency Name",
  },
  endDateFilterLabelForm: {
    id: baseId + "endDateFilterLabelForm",
    defaultMessage: "End date",
  },
  endDateFilter2LabelForm: {
    id: baseId + "endDateFilter2LabelForm",
    defaultMessage: "End date",
  },
  entitlementFilterLabelForm: {
    id: baseId + "entitlementFilterLabelForm",
    defaultMessage: "Entitlement",
  },
  entitlementDescriptionFilterLabelForm: {
    id: baseId + "entitlementDescriptionFilterLabelForm",
    defaultMessage: "Entitlement description",
  },
  entitlementIdFilterLabelForm: {
    id: baseId + "entitlementIdFilterLabelForm",
    defaultMessage: "Entitlement id",
  },
  entitlementNameFilterLabelForm: {
    id: baseId + "entitlementNameFilterLabelForm",
    defaultMessage: "Entitlement name",
  },
  fieldAreaFilterLabelForm: {
    id: baseId + "fieldAreaFilterLabelForm",
    defaultMessage: "Area",
  },
  fieldCodeFilterLabelForm: {
    id: baseId + "fieldCodeFilterLabelForm",
    defaultMessage: "Code",
  },
  fieldIdFilterLabelForm: {
    id: baseId + "fieldIdFilterLabelForm",
    defaultMessage: "fieldId",
  },
  fieldNameFilterLabelForm: {
    id: baseId + "fieldNameFilterLabelForm",
    defaultMessage: "fieldName",
  },
  fieldOrderFilterLabelForm: {
    id: baseId + "fieldOrderFilterLabelForm",
    defaultMessage: "Order",
  },
  fieldTypeFilterLabelForm: {
    id: baseId + "fieldTypeFilterLabelForm",
    defaultMessage: "Type",
  },
  fieldValueFilterLabelForm: {
    id: baseId + "fieldValueFilterLabelForm",
    defaultMessage: "fieldValue",
  },
  forceChangePwdFilterLabelForm: {
    id: baseId + "forceChangePwdFilterLabelForm",
    defaultMessage: "Force change password YES",
  },
  forceChangePwdFilter2LabelForm: {
    id: baseId + "forceChangePwdFilter2LabelForm",
    defaultMessage: "NO",
  },
  idFilterLabelForm: {
    id: baseId + "idFilterLabelForm",
    defaultMessage: "identitySystem",
  },
  idExternalFilterLabelForm: {
    id: baseId + "idExternalFilterLabelForm",
    defaultMessage: "idExternal",
  },
  idFieldFilterLabelForm: {
    id: baseId + "idFieldFilterLabelForm",
    defaultMessage: "idFieldFilter",
  },
  idServiceRequestFilterLabelForm: {
    id: baseId + "idServiceRequestFilterLabelForm",
    defaultMessage: "idServiceRequest",
  },
  idTemplateFilterLabelForm: {
    id: baseId + "idTemplateFilterLabelForm",
    defaultMessage: "idTemplate",
  },
  idTicketTemplateFilterLabelForm: {
    id: baseId + "idTicketTemplateFilterLabelForm",
    defaultMessage: "idTicketTemplate",
  },
  identitySystemIdFilterLabelForm: {
    id: baseId + "identitySystemIdFilterLabelForm",
    defaultMessage: "identitySystem",
  },
  inChargeOfFilterLabelForm: {
    id: baseId + "inChargeOfFilterLabelForm",
    defaultMessage: "In charge of",
  },
  lastChangePwdFilterLabelForm: {
    id: baseId + "lastChangePwdFilterLabelForm",
    defaultMessage: "Last change pwd START",
  },
  lastChangePwdFilter2LabelForm: {
    id: baseId + "lastChangePwdFilterLabelForm",
    defaultMessage: "END",
  },
  lengthFilterLabelForm: {
    id: baseId + "lengthFilterLabelForm",
    defaultMessage: "Length",
  },
  managerFilterLabelForm: {
    id: baseId + "managerFilterLabelForm",
    defaultMessage: "Manager",
  },
  managerFullNameFilterLabelForm: {
    id: baseId + "managerFullNameFilterLabelForm",
    defaultMessage: "Manager's name and/or surname",
  },
  managerIdFilterLabelForm: {
    id: baseId + "managerIdFilterLabelForm",
    defaultMessage: "Id manager",
  },
  maxDurationFilterLabelForm: {
    id: baseId + "maxDurationFilterLabelForm",
    defaultMessage: "Max duration",
  },
  maxValidityHoursFilterLabelForm: {
    id: baseId + "maxValidityHoursFilterLabelForm",
    defaultMessage: "Max validity hours",
  },
  nameFilterLabelForm: {
    id: baseId + "nameFilterLabelForm",
    defaultMessage: "Name",
  },
  netsIdFilterLabelForm: {
    id: baseId + "netsIdFilterFilterLabelForm",
    defaultMessage: "Nets id",
  },
  netsOrgunitIdFilterLabelForm: {
    id: baseId + "netsOrgunitIdFilterLabelForm",
    defaultMessage: "Nets organizational unit",
  },
  netsPersonIdFilterLabelForm: {
    id: baseId + "netsPersonIdFilterLabelForm",
    defaultMessage: "Nets person id",
  },
  numberLoginErrorFilterLabelForm: {
    id: baseId + "numberLoginErrorFilterLabelForm",
    defaultMessage: "N° Error login",
  },
  objectDescFilterLabelForm: {
    id: baseId + "objectDescFilterLabelForm",
    defaultMessage: "object Desc",
  },
  objectFilterLabelForm: {
    id: baseId + "objectFilterLabelForm",
    defaultMessage: "OBJECT",
  },
  objectIdFilterLabelForm: {
    id: baseId + "objectIdFilterLabelForm",
    defaultMessage: "object Id",
  },
  objectIdentitySystemIdFilterLabelForm: {
    id: baseId + "objectIdentitySystemIdFilterLabelForm",
    defaultMessage: " object Identity System Id",
  },
  objectTypeFilterLabelForm: {
    id: baseId + "objectTypeFilterLabelForm",
    defaultMessage: "object Type",
  },
  oldManagerFilterLabelForm: {
    id: baseId + "oldManagerFilterLabelForm",
    defaultMessage: "Old Manager",
  },
  oldOuCodeFilterLabelForm: {
    id: baseId + "oldOuCodeFilterLabelForm",
    defaultMessage: "Old Ou code",
  },
  operationFilterLabelForm: {
    id: baseId + "operationFilterLabelForm",
    defaultMessage: "operation",
  },
  operationByFilterLabelForm: {
    id: baseId + "operationByFilterLabelForm",
    defaultMessage: "operation by",
  },
  organizationalUnitFilterLabelForm: {
    id: baseId + "organizationalUnitFilterLabelForm",
    defaultMessage: "Organizational Unit",
  },
  ownerFilterLabelForm: {
    id: baseId + "ownerFilterLabelForm",
    defaultMessage: "Owner",
  },
  ouCodeFilterLabelForm: {
    id: baseId + "ouCodeFilterLabelForm",
    defaultMessage: "OU Code",
  },
  ouIdCounterFilterLabelForm: {
    id: baseId + "ouIdCounterFilterLabelForm",
    defaultMessage: "OU ID Counter",
  },
  ouTypeFilterLabelForm: {
    id: baseId + "ouTypeFilterLabelForm",
    defaultMessage: "OU Type",
  },
  parameterFilterLabelForm: {
    id: baseId + "parameterFilterLabelForm",
    defaultMessage: "Parameter",
  },
  prefixFilterLabelForm: {
    id: baseId + "prefixFilterLabelForm",
    defaultMessage: "Prefix",
  },
  propertyFilterLabelForm: {
    id: baseId + "propertyFilterLabelForm",
    defaultMessage: "Property",
  },
  queryFilterLabelForm: {
    id: baseId + "queryFilterLabelForm",
    defaultMessage: "Query",
  },
  revisorFilterLabelForm: {
    id: baseId + "revisorFilterLabelForm",
    defaultMessage: "Revisor",
  },
  roleFilterLabelForm: {
    id: baseId + "roleFilterLabelForm",
    defaultMessage: "Role",
  },
  serviceRequestIdFilterLabelForm: {
    id: baseId + "serviceRequestIdFilterLabelForm",
    defaultMessage: "serviceRequestIdFilter",
  },
  serviceRequestNameFilterLabelForm: {
    id: baseId + "serviceRequestNameFilterLabelForm",
    defaultMessage: "serviceRequestNameFilter",
  },
  showOnFrontendFilterLabelForm: {
    id: baseId + "showOnFrontendFilterLabelForm",
    defaultMessage: "Show On Frontend",
  },
  sourceTargetIdFilterLabelForm: {
    id: baseId + "sourceTargetIdFilterLabelForm",
    defaultMessage: "Source target id",
  },
  sourceIdentitySystemIdFilterLabelForm: {
    id: baseId + "sourceIdentitySystemIdFilterLabelForm",
    defaultMessage: "Source target identity id",
  },
  startDateFilterLabelForm: {
    id: baseId + "startDateFilterLabelForm",
    defaultMessage: "Start date",
  },
  startDateFilter2LabelForm: {
    id: baseId + "startDateFilter2LabelForm",
    defaultMessage: "Start date",
  },
  statusFilterLabelForm: {
    id: baseId + "statusFilterLabelForm",
    defaultMessage: "Status",
  },
  stepCodeFilterLabelForm: {
    id: baseId + "stepCodeFilterLabelForm",
    defaultMessage: "Step Code",
  },
  stepDescriptionFilterLabelForm: {
    id: baseId + "stepDescriptionFilterLabelForm",
    defaultMessage: "Step Description",
  },
  stepIdFilterLabelForm: {
    id: baseId + "stepIdFilterLabelForm",
    defaultMessage: "Step ID",
  },
  subjectDescFilterLabelForm: {
    id: baseId + "subjectDescFilterLabelForm",
    defaultMessage: "subject Desc",
  },
  subjectFilterLabelForm: {
    id: baseId + "subjectFilterLabelForm",
    defaultMessage: "Subject",
  },
  subjectIdFilterLabelForm: {
    id: baseId + "subjectIdFilterLabelForm",
    defaultMessage: " subject Id",
  },
  subjectIdentitySystemIdFilterLabelForm: {
    id: baseId + "subjectIdentitySystemIdFilterLabelForm",
    defaultMessage: "subject Identity System Id",
  },
  subjectTypeFilterLabelForm: {
    id: baseId + "subjectTypeFilterLabelForm",
    defaultMessage: "subject Type",
  },
  supervisorFilterLabelForm: {
    id: baseId + "supervisorFullNameFilterLabelForm",
    defaultMessage: "Supervisor",
  },
  supervisorFullNameFilterLabelForm: {
    id: baseId + "supervisorFullNameFilterLabelForm",
    defaultMessage: "Supervisor",
  },
  surnameFilterLabelForm: {
    id: baseId + "surnameFilterLabelForm",
    defaultMessage: "Surname",
  },
  textFilterLabelForm: {
    id: baseId + "textFilterLabelForm",
    defaultMessage: "Text",
  },
  tiCodeFilterLabelForm: {
    id: baseId + "tiCodeFilterLabelForm",
    defaultMessage: "TI code",
  },
  ticketNumberFilterLabelForm: {
    id: baseId + "ticketNumberFilterLabelForm",
    defaultMessage: "N° ticket",
  },
  ticketSystemIdFilterLabelForm: {
    id: baseId + "ticketSystemIdFilterLabelForm",
    defaultMessage: "ticketSystemId",
  },
  titleFilterLabelForm: {
    id: baseId + "titleFilterLabelForm",
    defaultMessage: "title",
  },
  typeFilterLabelForm: {
    id: baseId + "typeFilterLabelForm",
    defaultMessage: "Type",
  },
  uidMasterFilterLabelForm: {
    id: baseId + "uidMasterFilterLabelForm",
    defaultMessage: "Master uid",
  },
  uploadDateFilterLabelForm: {
    id: baseId + "uploadDateFilterLabelForm",
    defaultMessage: "Upload from",
  },
  uploadDateFilter2LabelForm: {
    id: baseId + "uploadDateFilter2LabelForm",
    defaultMessage: "to",
  },
  userCodeFilterLabelForm: {
    id: baseId + "userCodeFilterLabelForm",
    defaultMessage: "User code",
  },
  userIdFilterLabelForm: {
    id: baseId + "userIdFilterLabelForm",
    defaultMessage: "User id",
  },
  userTypeFilterLabelForm: {
    id: baseId + "userTypeFilterLabelForm",
    defaultMessage: "User type",
  },
  technicalUserTypeFilterLabelForm: {
    id: baseId + "technicalUserTypeFilterLabelForm",
    defaultMessage: "Technical user type",
  },
  valueFilterLabelForm: {
    id: baseId + "valueFilterLabelForm",
    defaultMessage: "Value",
  },
  validityHoursFilterLabelForm: {
    id: baseId + "validityHoursFilterLabelForm",
    defaultMessage: "Max hours",
  },
  workflowIdFilterLabelForm: {
    id: baseId + "workflowIdFilterLabelForm",
    defaultMessage: "Workflow ID",
  },

  // IDENTITY
  ITA: {
    id: baseId + "ITA",
    defaultMessage: "ITA",
  },
  NOR: {
    id: baseId + "NOR",
    defaultMessage: "NOR",
  },

  // TEMPORARY ENTITLEMENT TYPE
  POOL: {
    id: baseId + "POOL",
    defaultMessage: "POOL",
  },
  NON_POOL: {
    id: baseId + "NON_POOL",
    defaultMessage: "NON POOL",
  },
  NOT_POOL: {
    id: baseId + "NOT_POOL",
    defaultMessage: "NON POOL",
  },

  // REQ TYPE
  ADD_BUSINESS_ROLE_TO_USER: {
    id: baseId + "ADD_BUSINESS_ROLE_TO_USER",
    defaultMessage: "ADD BUSINESS ROLE TO USER",
  },
  ADD_EMERGENCY_USER_RACF: {
    id: baseId + "ADD_EMERGENCY_USER_RACF",
    defaultMessage: "ADD EMERGENCY USER RACF",
  },
  ADD_ENTITLEMENT_TO_CATALOG: {
    id: baseId + "ADD_ENTITLEMENT_TO_CATALOG",
    defaultMessage: "ADD ENTITLEMENT TO CATALOG",
  },
  ADD_ENTITLEMENT_TO_TECHNICAL_USER: {
    id: baseId + "ADD_ENTITLEMENT_TO_TECHNICAL_USER",
    defaultMessage: "ADD ENTITLEMENT TO TECHNICAL USER",
  },
  ADD_ENTITLEMENT_TO_USER: {
    id: baseId + "ADD_ENTITLEMENT_TO_USER",
    defaultMessage: "ADD ENTITLEMENT TO USER",
  },
  ADD_TEMPORARY_ENTITLEMENT: {
    id: baseId + "ADD_TEMPORARY_ENTITLEMENT",
    defaultMessage: "ADD TEMPORARY ENTITLEMENT",
  },
  CHANGE_PASSWORD: {
    id: baseId + "CHANGE_PASSWORD",
    defaultMessage: "CHANGE PASSWORD",
  },
  CREATE_BUSINESS_ROLE: {
    id: baseId + "CREATE_BUSINESS_ROLE",
    defaultMessage: "CREATE BUSINESS ROLE",
  },
  DELETE_BUSINESS_ROLE: {
    id: baseId + "DELETE_BUSINESS_ROLE",
    defaultMessage: "DELETE BUSINESS ROLE",
  },
  DELETE_TECHNICAL_USER: {
    id: baseId + "DELETE_TECHNICAL_USER",
    defaultMessage: "DELETE TECHNICAL USER",
  },
  REMOVE_BUSINESS_ROLE_TO_USER: {
    id: baseId + "REMOVE_BUSINESS_ROLE_TO_USER",
    defaultMessage: "REMOVE BUSINESS ROLE TO USER",
  },
  REMOVE_ENTITLEMENT_FROM_CATALOG: {
    id: baseId + "REMOVE_ENTITLEMENT_FROM_CATALOG",
    defaultMessage: "REMOVE ENTITLEMENT FROM CATALOG",
  },
  REMOVE_ENTITLEMENT_FROM_TECHNICAL_USER: {
    id: baseId + "REMOVE_ENTITLEMENT_FROM_TECHNICAL_USER",
    defaultMessage: "REMOVE ENTITLEMENT FROM TECHNICAL USER",
  },
  REMOVE_ENTITLEMENT_FROM_USER: {
    id: baseId + "REMOVE_ENTITLEMENT_FROM_USER",
    defaultMessage: "REMOVE ENTITLEMENT FROM USER",
  },
  REPORT_GENERETING: {
    id: baseId + "REPORT_GENERETING",
    defaultMessage: "REPORT GENERETING",
  },
  RESET_PASSWORD: {
    id: baseId + "RESET_PASSWORD",
    defaultMessage: "RESET PASSWORD",
  },
  SERVICE_REQUEST: {
    id: baseId + "SERVICE_REQUEST",
    defaultMessage: "SERVICE REQUEST",
  },
  TECHNICAL_USER_RESET_PWD: {
    id: baseId + "TECHNICAL_USER_RESET_PWD",
    defaultMessage: "TECHNICAL USER RESET PWD",
  },
  TECHNICAL_USER_CHANGE_PWD: {
    id: baseId + "TECHNICAL_USER_CHANGE_PWD",
    defaultMessage: "TECHNICAL USER CHANGE PWD",
  },
  CREATE_TECH_USER: {
      id: baseId + "CREATE_TECH_USER",
      defaultMessage: "CREATE TECHNICAL USER",
    },
  UPDATE_BUSINESS_ROLE: {
    id: baseId + "UPDATE_BUSINESS_ROLE",
    defaultMessage: "UPDATE BUSINESS ROLE",
  },

  // SOD CONFLICT TYPES
  BLOCK: {
    id: baseId + "BLOCK",
    defaultMessage: "BLOCK",
  },
  OVERRIDE: {
    id: baseId + "OVERRIDE",
    defaultMessage: "OVERRIDE",
  },
  WARNING: {
    id: baseId + "WARNING",
    defaultMessage: "WARNING",
  },
  WORKFLOW: {
    id: baseId + "WORKFLOW",
    defaultMessage: "WORKFLOW",
  },

  // CAMPAIGN TYPES
  ACCOUNT: {
    id: baseId + "ACCOUNT",
    defaultMessage: "ACCOUNT",
  },
  BUSINESS_ROLE: {
    id: baseId + "BUSINESS_ROLE",
    defaultMessage: "BUSINESS_ROLE",
  },
  ORGANIZATIONALUNIT: {
    id: baseId + "ORGANIZATIONALUNIT",
    defaultMessage: "ORGANIZATIONALUNIT",
  },
  OU: {
    id: baseId + "OU",
    defaultMessage: "OU",
  },
  USER: {
    id: baseId + "USER",
    defaultMessage: "USER",
  },

  // CAMPAIGN ACTION
  KEEP: {
    id: baseId + "KEEP",
    defaultMessage: "KEEP",
  },
  REVOKE: {
    id: baseId + "REVOKE",
    defaultMessage: "REVOKE",
  },
  VALIDATE: {
    id: baseId + "VALIDATE",
    defaultMessage: "VALIDATE",
  },

  // REQ STATUS
  APPROVAL: {
    id: baseId + "APPROVAL",
    defaultMessage: "APPROVAL",
  },
  COMPLETED: {
    id: baseId + "COMPLETED",
    defaultMessage: "COMPLETED",
  },
  ERROR: {
    id: baseId + "ERROR",
    defaultMessage: "ERROR",
  },
  EXECUTION: {
    id: baseId + "EXECUTION",
    defaultMessage: "EXECUTION",
  },
  _EXECUTION: {
    id: baseId + "_EXECUTION",
    defaultMessage: "_EXECUTION",
  },
  REFUSED: {
    id: baseId + "REFUSED",
    defaultMessage: "REFUSED",
  },
  RETRY: {
    id: baseId + "RETRY",
    defaultMessage: "RETRY",
  },

  // ACCOUNT STATUS
  ACTIVE: {
    id: baseId + "ACTIVE",
    defaultMessage: "ACTIVE",
  },
  INACTIVE: {
    id: baseId + "INACTIVE",
    defaultMessage: "INACTIVE",
  },

  // CAMPAIGN STATUS
  CLOSED: {
    id: baseId + "CLOSED",
    defaultMessage: "CLOSED",
  },
  /*
  allready present above
  COMPLETED: {
    id: baseId + "COMPLETED",
    defaultMessage: "COMPLETED",
  },
  */
  IN_PROGRESS: {
    id: baseId + "IN_PROGRESS",
    defaultMessage: "IN_PROGRESS",
  },
  SCHEDULED: {
    id: baseId + "SCHEDULED",
    defaultMessage: "SCHEDULED",
  },
  STARTING: {
    id: baseId + "STARTING",
    defaultMessage: "STARTING",
  },

  // CAMPAIGN ITEM STATUS
  CLOSE: {
    id: baseId + "CLOSE",
    defaultMessage: "CLOSE",
  },
  MIXED: {
    id: baseId + "MIXED",
    defaultMessage: "MIXED",
  },
  OPEN: {
    id: baseId + "OPEN",
    defaultMessage: "OPEN",
  },
  PENDING_VALIDATION: {
    id: baseId + "PENDING_VALIDATION",
    defaultMessage: "PENDING VALIDATION",
  },
  PENDING_EXECUTION: {
    id: baseId + "PENDING_EXECUTION",
    defaultMessage: "PENDING EXECUTION",
  },

  // TASK OPERATION TYPE
  ACCOUNT_CREATE: {
    id: baseId + "ACCOUNT_CREATE",
    defaultMessage: "ACCOUNT_CREATE",
  },
  ACCOUNT_DISABLE: {
    id: baseId + "ACCOUNT_DISABLE",
    defaultMessage: "ACCOUNT_DISABLE",
  },
  ACCOUNT_ENABLE: {
    id: baseId + "ACCOUNT_ENABLE",
    defaultMessage: "ACCOUNT_ENABLE",
  },
  ACCOUNT_MODIFY: {
    id: baseId + "ACCOUNT_MODIFY",
    defaultMessage: "ACCOUNT_MODIFY",
  },
  ACCOUNT_PWDCHANGE: {
    id: baseId + "ACCOUNT_PWDCHANGE",
    defaultMessage: "ACCOUNT_PWDCHANGE",
  },
  ACCOUNT_REMOVE: {
    id: baseId + "ACCOUNT_REMOVE",
    defaultMessage: "ACCOUNT_REMOVE",
  },
  AGGREGATED: {
    id: baseId + "AGGREGATED",
    defaultMessage: "AGGREGATED",
  },
  PERMISSION_ADD: {
    id: baseId + "PERMISSION_ADD",
    defaultMessage: "PERMISSION_ADD",
  },
  PERMISSION_REMOVE: {
    id: baseId + "PERMISSION_REMOVE",
    defaultMessage: "PERMISSION_REMOVE",
  },

  // TRUE FALSE
  TRUE: {
    id: baseId + "TRUE",
    defaultMessage: "TRUE",
  },
  FALSE: {
    id: baseId + "FALSE",
    defaultMessage: "FALSE",
  },
  true: {
    id: baseId + "TRUE",
    defaultMessage: "TRUE",
  },
  false: {
    id: baseId + "FALSE",
    defaultMessage: "FALSE",
  },

  // RACF TYPES
  BUG_FIXING: {
    id: baseId + "BUG_FIXING",
    defaultMessage: "BUG_FIXING",
  },
  INCIDENT: {
    id: baseId + "INCIDENT",
    defaultMessage: "INCIDENT",
  },
  CHANGE: {
    id: baseId + "CHANGE",
    defaultMessage: "CHANGE",
  },

  // COUNTER TYPES
  TECHNICAL_USER: {
    id: baseId + "TECHNICAL_USER",
    defaultMessage: "TECHNICAL USER",
  },
  Robot: {
    id: baseId + "Robot",
    defaultMessage: "ROBOT USER",
  },
  Service: {
    id: baseId + "Service",
    defaultMessage: "SERVICE USER",
  },
  TECHNICAL_IDENTITY: {
    id: baseId + "TECHNICAL_IDENTITY",
    defaultMessage: "TECHNICAL IDENTITY",
  },
})
